import React from 'react';
import { Text, TextProps } from './defaultUIComponents';

export const NoData: React.FC<TextProps> = (props) => {
  return (
    <Text id="nodata" fontSize="2xl" {...props}>
      nodata.nodata
    </Text>
  );
};
